module.exports = {
    APP_ENV: process.env.REACT_APP_ENV,
    APP_BACKEND_URL: process.env.REACT_APP_BACKEND_URL,
    AUTH_TOKEN: process.env.REACT_APP_AUTH_TOKEN,
    CMS_GIT_URL: process.env.REACT_APP_CMS_GIT || "https://content-hub.maybanksandbox.com/api/v2/content-config/MY/M2U/production/search/search-default",
}